import { createFileRoute } from "@tanstack/react-router";
import TmsForParamedics from "@/pages/TmsForParamedics";
export const Route = createFileRoute("/tms-for-paramedics")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "TMS For Paramedics | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "TMS for paramedics facing depression and occupational stress. Learn about treatment options at Neuro Wellness TMS in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:title",
          content: "TMS For Paramedics | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "TMS for paramedics facing depression and occupational stress. Learn about treatment options at Neuro Wellness TMS in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/tms-for-paramedics",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/tms-for-paramedics",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <TmsForParamedics />;
}
